import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { ElementProps } from './element.props'

export const ElementType = ComponentTypeFactory.create<ElementProps>(
  'Element',
  {
    tag: FieldTypeFactory.text(),
    className: FieldTypeFactory.text(),
  }
)
